



















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import infiniteScroll from "vue-infinite-scroll";
import QErrors from "@/common/qErrors.vue";
import deliveryDestinationApi from "@/api/deliveryDestinationApi";
import mDeliveryDestination from "@/model/mDeliveryDestination";
import PaginateModel from "@/model/paginate";
import DeliveryDestinationEditPopUp from "@/components/cutomer/deliveryDestination/deliveryDestinationEditPopUp.vue";
import _isEmpty from "lodash/isEmpty";

Vue.use(infiniteScroll);

@Component({
  name: "DeliveryDestinationList",
  components: {
    QErrors,
    DeliveryDestinationEditPopUp,
  },
})
export default class DeliveryDestinationList extends Vue {
  public isShow = false;
  public pagination = new PaginateModel({
    page: 1,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public deliveries: mDeliveryDestination[] = [];
  public searchParams = {
    dlv_dst_name: "",
    tel_number: "",
  };
  public deliverySelected = new mDeliveryDestination();
  public busy = false;
  public mainClass = "mb__popup-area";
  public boxClass = "mb__popup-box";
  public itemClass = "mb__popup-item";
  public titleClass = "mb__popup-title AddButton";
  public contentClass = "mb__popup-contents";
  public addButtonClass = "mb__button mb__add-color-green";
  public isClear = false;
  public errors = {};

  @Prop({ default: true }) isModal: boolean;

  get isError() { return !_isEmpty(this.errors); }

  public mounted() {
    this.initialSearch();
    if (!this.isModal) {
      this.mainClass = "mb__form-group";
      this.boxClass = "mb__form-group";
      this.itemClass = "mb__form-group";
      this.titleClass = "mb__form-group-title";
      this.contentClass = "FormGroupBox";
      this.addButtonClass = "mb__button mb__add-color-green AddButton";
    }
    this.errors = {};
  }

  public initialSearch() {
    this.busy = false;
    this.pagination = new PaginateModel({
      page: 1,
      pageCount: 0,
      start: 0,
      end: 0,
      count: 0,
    });
    this.searchParams = {
      dlv_dst_name: "",
      tel_number: "",
    };
  }

  public async search() {
    this.deliveries = [];
    await this.getAll();
  }

  public async clear() {
    this.initialSearch();
    this.deliveries = [];
    this.isClear = true;
    await this.search();
  }

  public async getAll(parameters = {}) {
    const query = { ...this.searchParams, ...parameters };
    const result = await deliveryDestinationApi.getAll(query);

    result.list.map((delivery) => {
      delivery.address_2 = delivery.address_2 ?? ''
      this.deliveries.push(delivery);
    });

    this.pagination = result.paginate;
  }

  public showPopUp(delivery: mDeliveryDestination) {
    (this.$refs
      .DeliveryDestinationEditPopUp as DeliveryDestinationEditPopUp).show(
      delivery ? {...delivery} : null
    );
  }

  public showMe() {
    this.errors = {};
    this.isShow = true;
  }

  public hideMe() {
    this.isShow = false;
  }

  public selectDelivery(delivery) {
    if (!this.isModal) {
      return;
    }
    this.deliverySelected = delivery;
  }

  public submit() {
    if (this.deliverySelected.postal_code == "") {
      this.errors = {
        no_selected : {
          0 : this.$t("common.delivery_no_selected")
        }
      }
      return;
    }
    this.$emit("deliverySelected", this.deliverySelected);
    this.hideMe();
  }

  public async loadMore() {
    this.busy = true;
    if (!this.isClear) {
      await this.getAll({
        page: this.pagination.page,
      });
    }
    this.pagination.page++;

    if (this.pagination.page > this.pagination.end) {
      this.busy = true;
      return;
    }

    this.busy = false;
    this.isClear = false;
  }
}
